
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/platnosci/faktury",
      function () {
        return require("private-next-pages/moje-konto/platnosci/faktury.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/platnosci/faktury"])
      });
    }
  